import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { playSoundEffect } from '../hooks/useSoundEffects';
import MenuPaintedButton from '../components/MenuPaintedButton';
import {
  WAR_EFFORT_LEAVE_MISSION_BUTTON_PATH,
  WAR_EFFORT_PRIMARY_BUTTON_PATH,
  WAR_EFFORT_REFRESH_BUTTON_PATH,
} from '../config/welcomeAssets';
import './ConfirmationDialog.css';

/**
 * ConfirmationDialog Component
 * Replaces native window.confirm() with a styled confirmation dialog
 */
const ConfirmationDialog = ({
  message,
  onConfirm,
  onCancel,
  confirmText = 'OK',
  cancelText = 'Cancel',
  type = 'warning'
}) => {
  useEffect(() => {
    playSoundEffect('/sounds/click.mp3', 0.3);
  }, []);

  const handleConfirm = () => {
    if (!onConfirm) {
      throw new Error('ConfirmationDialog requires onConfirm');
    }
    onConfirm();
  };

  const handleCancel = () => {
    if (!onCancel) {
      throw new Error('ConfirmationDialog requires onCancel');
    }
    onCancel();
  };

  const handleOverlayClick = (e) => {
    if (e.target.className === 'confirmation-overlay' || e.target.classList?.contains('confirmation-overlay')) {
      handleCancel();
    }
  };

  const typeClass = `confirmation-dialog-${type}`;
  const isDanger = type === 'danger';
  const cancelImagePath = isDanger ? WAR_EFFORT_PRIMARY_BUTTON_PATH : WAR_EFFORT_REFRESH_BUTTON_PATH;
  const confirmImagePath = isDanger ? WAR_EFFORT_LEAVE_MISSION_BUTTON_PATH : WAR_EFFORT_PRIMARY_BUTTON_PATH;

  return createPortal(
    <div
      className="confirmation-overlay"
      onClick={handleOverlayClick}
      style={{ zIndex: 1000000 }}
    >
      <div className={`confirmation-dialog ${typeClass}`} style={{ zIndex: 1000001 }}>
        <div className="confirmation-dialog-content">
          <div className="confirmation-dialog-message">
            {message.split('\n').map((line, index) => (
              <p key={index} style={{ margin: index > 0 ? '8px 0 0 0' : '0' }}>
                {line}
              </p>
            ))}
          </div>
          <div className="confirmation-dialog-actions">
            <MenuPaintedButton
              className="confirmation-button confirmation-button-cancel"
              imagePath={cancelImagePath}
              onClick={handleCancel}
            >
              {cancelText}
            </MenuPaintedButton>
            <MenuPaintedButton
              className="confirmation-button confirmation-button-confirm"
              imagePath={confirmImagePath}
              onClick={handleConfirm}
            >
              {confirmText}
            </MenuPaintedButton>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmationDialog;
